/* eslint-disable max-len */
import { CROSS_SELLING_GET_REFERENCES_URL } from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { GetCrossSellingReferences } from '@1po/1po-bff-fe-spec/generated/backoffice/cross_selling/request/GetCrossSellingReferences';
import { UserContext } from '@1po/1po-bff-fe-spec/generated/basket/request/AddReferences';
import { GetEquivalentReferencesRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetEquivalentReferencesRequest';
import { GetExadisEligibleReferencesRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetExadisEligibleReferencesRequest';
import { GetIsDiscontinuedReferenceRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetIsDiscontinuedReferenceRequest';
import { GetPlatesForReferenceRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetPlatesForReferenceRequest';
import { GetReference3DModelRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetReference3dModelRequest';
import { GetReuseAvailabilitiesRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetReuseAvailabilitiesRequest';
import { GetReuseStockRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/dh/request/GetReuseStockRequest';
import { GetIAMReferenceApplicabilityRequest } from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/request/GetIAMReferenceApplicabilityRequest';
import { CheckIfStocksAreStillUpToDateRequest } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/CheckIfStocksAreStillUpToDateRequest';
import {
  GetReferencesStockRequest,
  ReferenceStockTradingDataRequestDetail,
} from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/GetReferencesStockRequest';
import {
  GetReferenceTradingDataRequest,
  ReferenceTradingDataRequestDetail,
} from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/request/GetReferenceTradingDataRequest';
import {
  CHECK_IF_STOCKS_ARE_UP_TO_DATE_URL,
  GET_EQUIVALENT_REFERENCES_URL,
  GET_EXADIS_ELIGIBLE_REFERENCES_URL,
  GET_IAM_REFERENCE_APPLICABILITY_URL,
  GET_IS_DISCONTINUED_REFERENCE_URL,
  GET_PLATES_FOR_REFERENCE,
  GET_REFERENCE_3D_MODEL_URL,
  GET_REFERENCES_DISCOUNTS_URL,
  GET_REFERENCES_PRICE_URL,
  GET_REFERENCES_REPAIR_PRICES_URL,
  GET_REFERENCES_STOCKS_URL,
  GET_REUSE_AVAILABILITIES_URL,
  GET_REUSE_STOCK_URL,
} from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

export function sendGetPlatesForReference(request: GetPlatesForReferenceRequest): WebSocketAction {
  return wsSendAction(GET_PLATES_FOR_REFERENCE, request);
}

export function sendGetReferencesPriceRequest(
  references: ReferenceTradingDataRequestDetail[],
  basketRequest: boolean,
): WebSocketAction {
  const request: GetReferenceTradingDataRequest = {
    references,
    basketRequest,
  };
  return wsSendAction(GET_REFERENCES_PRICE_URL, request);
}

export function sendGetReferencesDiscountRequest(references: ReferenceTradingDataRequestDetail[]): WebSocketAction {
  const request: GetReferenceTradingDataRequest = {
    references,
    basketRequest: false,
  };
  return wsSendAction(GET_REFERENCES_DISCOUNTS_URL, request);
}

export function sendGetReferencesRepairPricesRequest(references: ReferenceTradingDataRequestDetail[]): WebSocketAction {
  const request: GetReferenceTradingDataRequest = {
    references,
    basketRequest: false,
  };
  return wsSendAction(GET_REFERENCES_REPAIR_PRICES_URL, request);
}

export function sendGetCrossSellingReferences(request: GetCrossSellingReferences): WebSocketAction {
  return wsSendAction(CROSS_SELLING_GET_REFERENCES_URL, request);
}

export function sendGetReferencesStocksRequest(
  references: ReferenceStockTradingDataRequestDetail[],
  userContext: UserContext,
): WebSocketAction {
  const request: GetReferencesStockRequest = {
    references,
    userContext,
  };
  return wsSendAction(GET_REFERENCES_STOCKS_URL, request);
}

export function sendGetReuseStocks(referenceNumbers: string[], nodeId: string | undefined): WebSocketAction {
  const request: GetReuseStockRequest = {
    references: referenceNumbers,
    nodeId,
  };
  return wsSendAction(GET_REUSE_STOCK_URL, request);
}

export function sendGetReuseAvailabilities(referenceNumbers: string[]): WebSocketAction {
  const request: GetReuseAvailabilitiesRequest = {
    references: referenceNumbers,
  };
  return wsSendAction(GET_REUSE_AVAILABILITIES_URL, request);
}

export function sendGetEquivalents(request: GetEquivalentReferencesRequest): WebSocketAction {
  return wsSendAction(GET_EQUIVALENT_REFERENCES_URL, request);
}

export function sendGetExadisEligibleReferences(request: GetExadisEligibleReferencesRequest): WebSocketAction {
  return wsSendAction(GET_EXADIS_ELIGIBLE_REFERENCES_URL, request);
}

export function sendCheckIfStocksAreStillUpToDateRequest(
  request: CheckIfStocksAreStillUpToDateRequest,
): WebSocketAction {
  return wsSendAction(CHECK_IF_STOCKS_ARE_UP_TO_DATE_URL, request);
}

export function sendGetIsDiscontinuedReferenceRequest(request: GetIsDiscontinuedReferenceRequest): WebSocketAction {
  return wsSendAction(GET_IS_DISCONTINUED_REFERENCE_URL, request);
}

export function sendIAMReferenceApplicabilityRequest(
  userContext: UserContext,
  reference: GetIAMReferenceApplicabilityRequest['reference'],
): WebSocketAction {
  const request: GetIAMReferenceApplicabilityRequest = {
    userContext,
    reference,
  };

  return wsSendAction(GET_IAM_REFERENCE_APPLICABILITY_URL, request);
}

export function sendGetReference3dModelRequest(request: GetReference3DModelRequest): WebSocketAction {
  return wsSendAction(GET_REFERENCE_3D_MODEL_URL, request);
}
